import React, { Component } from 'react'
import { connect } from 'react-redux'

import Divider from 'material-ui/Divider'

import TenantCombobox from '../TenantCombobox'
import PropertyCombobox from '../PropertyCombobox'
import Comments from 'components/Comments'
import PaymentDate from '../PaymentDate'
import PaymentAmount from '../PaymentAmount'
import Attachments from 'components/Attachments'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		transaction: doc(state, props.transactionID)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		return(
			<div
				className="wrapper"
				style={{
					 width: (props.colspan>1)?"50%":"100%"
   				   , overflowY: (props.colspan>1)?"scroll":"hidden"
				   , overflowX: "hidden"
				}}
			>
			<div style={{width: "100%", padding:"10px 30px 0px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
				<TenantCombobox objectID={props.transactionID} />
				{props.transaction.partyID && <PropertyCombobox objectID={props.transactionID} />}
			</div>
			{props.transaction.partyID && props.transaction.propertyID &&
				<div style={{width: "100%", padding:"0 30px 0px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
					<PaymentDate objectID={props.transactionID} />
					<PaymentAmount objectID={props.transactionID} />
				</div>
			}
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/manager/transactionForm/DepositForm/LeftSide.js